import * as React from 'react'
import classNames from 'classnames'
import { PRODUCTS } from 'capacity/copy'
import './changeTag.scss'

export type ChangeTagKind = 'new' | 'changed' | 'removing' | 'notSaved'

interface ChangeTagProps {
    kind: ChangeTagKind
    className?: string
}

export function ChangeTag({ kind, className }: ChangeTagProps) {
    return <span className={classNames('change-tag', kind, className)}>{PRODUCTS.tags[kind]}</span>
}
